<template>
  <div>
    <app-navbar v-on:toggleDrawer="toggleDrawer"/>
    <app-drawer v-model="drawer" />
    <!-- mx-0 cancels the row's negative side margins. With no v-container to absorb
         them the row rendered wider than the viewport, which scrolled the whole page
         sideways on a phone. Column padding still provides the gutters. -->
    <v-row class="main pr-5 mx-0">
      <v-col class="sidebar-col" md="3" sm="0">
        <sidebar class="hidden-sm-and-down" />
      </v-col>
      <v-col md="9" sm="12" class="default-slot" > 
        <slot />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Sidebar from './Sidebar.vue';
import AppDrawer from './AppDrawer.vue';
import UserFeed from './UserFeed.vue';
import AppNavbar from './AppNavbar.vue';

export default Vue.extend({
  name: 'Home',
  props: {
    searchText: String,
  },
  components: {
    Sidebar,
    AppDrawer,
    UserFeed,
    AppNavbar,
  },
  data: function() {
    return {
      drawer: false
    };
  },
  created: function () {
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
    }
  }
});
</script>